


















































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import TranslationModule from '@/utils/TranslationModule'
import API from '@/services/API'
import { SearchHistory } from '@/types/search/SearchHistory.type'
import RouteName from '@/utils/RouteName'
import { namespace } from 'vuex-class'
import axios from 'axios'
import HeaderNavigationDropdown from '@/components/layout/header/navigation/HeaderNavigationDropdown.vue'
import { Club } from '@/types/Club.type'
import { BusinessCenter } from '@/types/BusinessCenter.type'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'

const BLOCK_SELECTOR = 'h-a-search'
const Search = namespace('search')
const request = axios.CancelToken.source()

@Component({
    components: { HeaderNavigationDropdown, BaseButton, BaseIcon },
})
export default class HeaderActionSearch extends Vue {
    @Prop({ type: String, required: true }) mode!: 'autocomplete' | 'search-all'
    @Search.State('history') searchHistory!: any

    TranslationModule: typeof TranslationModule = TranslationModule
    RouteName: typeof RouteName = RouteName
    inputExpanded = false
    showInput = false
    memberResults: Array<any> = []
    memberCount = 0
    eventResults: Array<any> = []
    eventCount = 0
    partnerResults: Array<any> = []
    partnerCount = 0
    inside = false
    currentMember = -1
    currentEvent = -1
    currentPartner = -1
    currentMemberHit?: any = null
    currentEventHit?: any = null
    currentPartnerHit?: any = null
    isLoading = false
    menuAnimated: string | null = null
    displayClubs = false
    displayBenefits = false
    displayBusinessCenters = false
    historyExpanded = false
    pending = false

    $refs!: {
        input: HTMLInputElement
        form: HTMLElement
    }

    @Watch('$route')
    onRouteChanged() {
        // close search if route has changed (else than search list page)
        this.reset(false)
    }

    @Watch('inputExpanded')
    onChangeInputExpanded() {
        if (this.inputExpanded) {
            this.showInput = true
        }
        document.dispatchEvent(
            new CustomEvent('mvb:header:autocomplete:expand', { detail: { status: this.inputExpanded } })
        )
    }

    afterLeaveAnimation() {
        this.inputExpanded = false
    }

    created() {
        if (this.mode === 'search-all') {
            this.inputExpanded = true
        }
    }

    get classList() {
        return [
            BLOCK_SELECTOR,
            {
                [`${BLOCK_SELECTOR}--open`]: this.inputExpanded,
            },
        ]
    }

    get isConnectedAsAdmin() {
        if (this.$store.state.user.decodedToken && this.$store.state.user.decodedToken.roles) {
            return this.$store.state.user.decodedToken.roles
        }

        return false
    }

    get isOnSwitchToMode() {
        // @ts-ignore
        return window.__isJwtSwitch
    }

    get clubs(): Array<{ url: string; name: string; id: number }> {
        return (this.$store.state.app.configuration?.forms?.clubs || [])
            .filter((club: Club) => club.slug !== 'beta')
            .map((club: Club) => ({
                id: club.id,
                name: club.name,
                url: `/clubs/${club.slug || club.name.toLocaleLowerCase().split(' ')[0]}/join`,
            }))
    }

    get hubs(): Array<{ url: string; name: string; id: number }> {
        return (this.$store.state.app.configuration?.forms?.hubs || []).map((businessCenter: BusinessCenter) => ({
            id: businessCenter.id,
            name: businessCenter.name,
            url: `/hubs/${businessCenter.slug}`,
        }))
    }

    get hasResults() {
        return this.memberResults.length > 0 || this.eventResults.length > 0 || this.partnerResults.length > 0
    }

    get hasHistory() {
        return this.searchText === '' && this.historyExpanded && this.searchHistory.results.length > 0
    }

    get hasSuggest() {
        return this.inputExpanded && (this.hasResults || this.hasHistory || this.isLoading)
    }

    get searchText(): string {
        return this.$store.state.search.searchText
    }

    set searchText(searchText: string) {
        this.$store.commit('search/SET_SEARCH_TEXT', searchText)
    }

    async search() {
        if (this.searchText === '') {
            this.clearResults()
            this.isLoading = false
            this.historyExpanded = true
            if (!this.searchHistory.loaded) {
                await this.$store.dispatch('search/loadSearchHistory')
            }

            return
        }

        try {
            this.isLoading = true
            const result: any = await API.postSearchHeaderAutocomplete(this.searchText, request.token)
            this.memberResults = result.member.results
            this.memberCount = result.member.count
            this.eventResults = result.event.results
            this.eventCount = result.event.count
            this.partnerResults = result.partner.results
            this.partnerCount = result.partner.count
        } catch (e) {
            console.error(e)
        } finally {
            this.isLoading = false
        }
    }

    expand() {
        if (!this.inputExpanded) {
            this.inputExpanded = true
            this.focusInput()
        }
    }

    handleClubsDisplay() {
        this.displayClubs = !this.displayClubs
    }

    handleBusinessCentersDisplay() {
        this.displayBusinessCenters = !this.displayBusinessCenters
    }

    clearResults() {
        this.memberResults = []
        this.memberCount = 0
        this.eventResults = []
        this.eventCount = 0
        this.partnerResults = []
        this.partnerCount = 0
    }

    checkEnter() {
        this.inside = true
    }

    checkLeave() {
        this.inside = false
        setTimeout(() => {
            if (!this.inside) {
                this.reset(true)
            }
        }, 2000)
    }

    reset(force: boolean) {
        this.clearResults()

        if (force || this.mode !== 'search-all') {
            this.showInput = false
        }
        this.historyExpanded = false
    }

    focusInput() {
        setTimeout(() => {
            // @ts-ignore
            this.$refs.input.focus()
            // @ts-ignore
            this.$refs.input.selectionStart = this.$refs.input.selectionEnd = this.$refs.input.value.length
        }, 400)
    }

    itemMemberClass(index: number): Record<string, any> {
        return {
            active: this.currentMember === index,
            hit: this.currentMemberHit === index,
        }
    }

    itemEventClass(index: number): Record<string, any> {
        return {
            active: this.currentEvent === index,
            hit: this.currentEventHit === index,
        }
    }

    itemPartnerClass(index: number): Record<string, any> {
        return {
            active: this.currentPartner === index,
            hit: this.currentPartnerHit === index,
        }
    }

    moreMembers() {
        // @ts-ignore
        window.location.href = `/members/all?search=${this.searchText}`
    }

    moreEvents() {
        window.location.href = `/events?search=${this.searchText}`
    }

    morePartners() {
        window.location.href = `${process.env.VUE_APP_CLUB_BASE_URL}/companies/search?search=${this.searchText}`
    }

    // Key controls
    up() {
        if (this.currentMember == -1 && this.currentEvent == -1) {
            this.currentEvent = this.eventResults.length - 1
        } else if (this.currentMember == -1 && this.currentEvent >= 0) {
            this.currentEvent--
            if (this.currentEvent == -1) {
                this.currentMember = this.memberResults.length - 1
            }
        } else if (this.currentEvent == -1 && this.currentMember >= 0) {
            this.currentMember--
            if (this.currentMember == -1) {
                this.currentEvent = this.eventResults.length - 1
            }
        }
    }

    down() {
        if (this.currentMember == -1 && this.currentEvent == -1) {
            this.currentMember = 0
        } else if (this.currentMember == -1 && this.currentEvent < this.eventResults.length - 1) {
            this.currentEvent++
        } else if (this.currentEvent == -1 && this.currentMember < this.memberResults.length - 1) {
            this.currentMember++
        } else if (this.currentEvent == -1 && this.currentMember == this.memberResults.length - 1) {
            this.currentMember = -1
            this.currentEvent = 0
        } else if (this.currentMember == -1 && this.currentEvent == this.eventResults.length - 1) {
            this.currentMember = 0
            this.currentEvent = -1
        }
    }

    setCurrentMember(index: number) {
        this.currentMember = index
        this.currentEvent = -1
    }

    setCurrentEvent(index: number) {
        this.currentEvent = index
        this.currentMember = -1
    }

    async submitSearch() {
        request.cancel()
        if (!this.pending) {
            this.pending = true
            if (this.mode === 'search-all') {
                this.clearResults()
                await this.$store.dispatch('search/loadAllResults')
            } else {
                if (this.$route.name !== RouteName.SEARCH_SEARCH_ALL) {
                    await this.$router.push({ name: RouteName.SEARCH_SEARCH_ALL, query: { search: this.searchText } })
                }
            }
            this.pending = false
        }
    }

    hitMember() {
        if (this.currentMember !== -1) {
            window.location.href = this.memberResults[this.currentMember].url
            document.dispatchEvent(
                new CustomEvent('mvb:header:autocomplete:hit', {
                    detail: { position: this.currentMemberHit + 1 },
                })
            )
        } else {
            this.moreMembers()
        }
    }

    hitEvent() {
        if (this.currentEvent !== -1) {
            window.location.href = this.eventResults[this.currentEvent].url
            document.dispatchEvent(
                new CustomEvent('mvb:header:autocomplete:hit', { detail: { position: this.currentEventHit + 1 } })
            )
        } else {
            this.moreEvents()
        }
    }

    hitPartner() {
        if (this.currentEvent !== -1) {
            window.location.href = this.partnerResults[this.currentPartner].url
            document.dispatchEvent(
                new CustomEvent('mvb:header:autocomplete:hit', { detail: { position: this.currentPartnerHit + 1 } })
            )
        } else {
            this.morePartners()
        }
    }

    onSelectSearchHistory(history: SearchHistory) {
        this.$store.commit('search/SET_SEARCH_TEXT', history.searchText)
        this.submitSearch()
    }

    onDeleteSearchHistory(history: SearchHistory) {
        this.$store.dispatch('search/deleteSearchHistory', history)
    }
}
